// extracted by mini-css-extract-plugin
export default {"feedBackBlock":"styles_feedBackBlock__AZqN6","feedBackBlock_text":"styles_feedBackBlock_text__cfyKw"};